import React, { useState } from "react";
import { Modal } from "react-bootstrap"

const PropertyVideoPlay = (props) => {
    const [show, setShow] = useState(false);

    const trackerVideo = (event) => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'Video Play Btn',
            'formType': event,
            'formId': 'Video Play',
            'formName': 'Video',
            'formLabel': 'Video'
        });
    }

    return (
        <>
            <a href="javascript:void(0)" onClick={() => { trackerVideo(props.title); setShow(true); }}>
                <i className="icon-play-blue"></i>
                <span className="d-none d-md-block">Video Tour</span>
            </a>

            {show &&
                <Modal
                    show={show}
                    onHide={() => setShow(false)}
                    dialogClassName="modal-video"
                    aria-labelledby="example-custom-modal-styling-title"
                    backdropClassName="video-backdrop"
                    className="main-full-video-popup"
                >
                    <Modal.Header closeButton>
                    </Modal.Header>
                    <Modal.Body>
                        <iframe
                            src={props.url}
                            width="100%"
                            height="100%"
                            frameBorder="0"
                            allow="autoplay; fullscreen"
                            allowFullScreen
                            title={props.title || "Property video"}
                        />
                    </Modal.Body>
                </Modal>
            }
        </>
    )
}

export default PropertyVideoPlay
